import { db, functions } from '.';

async function addConceptToDB(data) {
  const topicId = db.collection('topics').doc(data.topic.id);
  const conceptData = {
    name: data.name,
    poster: data.poster,
    steps: [],
    topicId
  };
  // Query to get concept which has the highest `serialNumber` so that we can
  // determine the serialNumber for new concept.
  const query = db
    .collection('concepts')
    .where('topicId', '==', topicId)
    .orderBy('serialNumber', 'desc')
    .limit(1);
  const querySnapshot = await query.get();
  const lastConcept = querySnapshot.docs[0];
  if (lastConcept) {
    conceptData.serialNumber = lastConcept.data().serialNumber + 1;
  } else {
    conceptData.serialNumber = 1;
  }
  const newConceptRef = db.collection('concepts').doc();
  await newConceptRef.set(conceptData);
  return newConceptRef;
}

async function getConceptFromDB(id) {
  const snapshot = await db
    .collection('concepts')
    .doc(id)
    .get();
  if (snapshot.exists) {
    const { topicId, ...data } = snapshot.data();
    const topicSnapshot = await topicId.get();
    return {
      ...data,
      id,
      topic: {
        name: topicSnapshot.data().name,
        id: topicSnapshot.id
      }
    };
  } else {
    throw new Error('No such concept!');
  }
}

/**
 * @param {String} conceptId Id of the concept to be published
 * @param {String} versionBump One of `minor`, `major` or 'admin'. If `minor` is
 * specified only new conceptAttempts will use the new version and if `major` is
 * specified then users with old version conceptAttempts will have an option to
 * upgrade to new version. if it is admin then admin version will be released.
 */
async function publishConcept(conceptId, versionBump) {
  const publishConceptCall = functions.httpsCallable('adminConceptsPublish');
  await publishConceptCall({ conceptId, versionBump });
}

async function updateConceptInDB(data) {
  const { id, topic, ...docData } = data;
  await db
    .collection('concepts')
    .doc(id)
    .update({
      ...docData,
      publishedToAdmin: false,
      ...(topic ? { topicId: db.collection('topics').doc(topic.id) } : {})
    });
}

export default {
  add: addConceptToDB,
  get: getConceptFromDB,
  publish: publishConcept,
  update: updateConceptInDB
};
